import io from 'socket.io-client';
import { Env } from "../config";

const socket = io(Env.REACT_APP_WEB_SOCKET, {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    transports: ['websocket'],
    auth: {
        platform: "leap_website"
    }
});


const bottomLinks = [
    { label: "LEAP5D", result: "/result/lmhsb-5d", tip: "/tips/lmhsb-5d" },
    { label: "LEAP6D", result: "/result/lmhsb-6d", tip: "/tips/lmhsb-6d" },
    { label: "MT", result: "/result/mt", tip: "/tips/mt" },
    { label: "TC", result: "/result/tc", tip: "/tips/tc" },
    { label: "MC", result: "/result/mc", tip: "/tips/mc" },
    { label: "SC", result: "/result/sc", tip: "/tips/sc" }
]

const titles = [
    "Albina Boyle",

    "Mattie Walter DVM",

    "Dr. Ewald DuBuque",

    "Ms. Aliya Towne PhD",

    "Malachi Barton"];
export { socket, bottomLinks, titles };

export const SCPostCode = {
    A: "ក",
    B: "ខ",
    C: "គ",
    D: "ឃ",
    E: "ង"
}

export const mapTypeLabel = {
    tn: "TC",
    mt: "MT",
    vnone: "MC",
    kp: "KP",
}


export const getPostNum = (num) => {
    if (num.includes("?") || num.includes("*")) return "";
    return num;
}

export const byCodes = (arr, codes) =>
    codes.map(code => arr.find(x => x.postCode === code)).filter(Boolean);

export const byAPrefix = (arr, max, pre = "A") => {
    const pick = arr.filter(x => {
        if (x.postCode === pre) return true; // include base A
        if (!x.postCode.startsWith(pre)) return false; // exclude non-A
        const n = parseInt(x.postCode.slice(1), 10);
        return Number.isInteger(n) && n >= 2 && n <= max;
    });
    return pick.sort((a, b) => {
        const va = a.postCode === pre ? 0 : parseInt(a.postCode.slice(1), 10);
        const vb = b.postCode === pre ? 0 : parseInt(b.postCode.slice(1), 10);
        return va - vb;
    });
};

export const convertStrToArr = (str) => {
    const arr = str.toString().split("");
    while (arr.length < 5) {
        arr.push("");
    }
    return arr.slice(0, 5);
}

export const splitArrayToStrings = (str) => {
    const digits = str.replace(/\D/g, '');
    const first = digits.slice(0, 2);
    const second = digits.slice(2);
    return [first, second];
}

export const chunkPostsKP = (list = [], is3rows = false) => {
    const result = [];
    if (is3rows) {
        for (let i = 0; i < list.length; i += 3) {
            result.push(list.slice(i, i + 3));
        }
        return result;
    } else {
        const groupSizes = [4, 3, 3];
        let start = 0;
        for (const size of groupSizes) {
            result.push(list.slice(start, start + size));
            start += size;
        }
        return result;
    }
}



